import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import _, { cloneDeep, isObject, each, isEqual, get, isFunction } from 'lodash';
import { __decorate, __param } from 'tslib';
import { BehaviorSubject, Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

const eventName$2 = 'adlEvent';
const ArticleViewEvent = 'articleView';
const ArticleFeedbackEvent = 'articleFeedback';
const hasTransactionIDStub = (pendingPayload) => {
    return (pendingPayload &&
        pendingPayload.selfServe &&
        pendingPayload.selfServe.transactionID &&
        typeof pendingPayload.selfServe.transactionID === 'object');
};
const postalCodeRegex = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]●?[0-9][A-Z][0-9]$/;
class ApplicationName {
} // to be overwritten by application.
class AnalyticsErrorBeacon {
    constructor(analyticsErrors) {
        this.events = {
            errors: true
        };
        this.errors = analyticsErrors;
    }
}
class NotificationBeacon {
    constructor(notification) {
        this.events = {
            notification: true
        };
        this.notification = notification;
    }
}
const ArticleEvent = {
    articleView: ArticleViewEvent,
    isHelpful: {
        yes: true,
        no: false
    },
    feedback: ArticleFeedbackEvent
};
class ArticleEvents {
}
/////SelfServe Const
const SelfServeEvents = {
    selfServeStart: 'selfServeStart',
    selfServeComplete: 'selfServeComplete',
    autoPay: 'autoPay'
};
const TRANSACTION_ID_SYMBOL = {
    symbol: 'transaction id'
};
/////////////
const ArticleHelpfulnessEvent = 'helpfulness';
class Page {
}
class MinimalPage {
}
class Site {
}
const interactionEventName = 'interaction';
const cmsInteractionEventName = 'cmsInteraction';
const miscEventName = 'miscellaneous';
const formView = 'formView';
const formStepView = 'formStepView';
const formComplete = 'formComplete';
class ArticleFeedback {
    constructor(title, type, lob, feedback) {
        this.article = new Article(title, type, lob, null, feedback);
    }
}
class Field {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
class Form {
    constructor(name, stepName, lob, fields, fieldsList) {
        this.name = name;
        this.stepName = stepName;
        this.lob = lob;
        this.fields = fields;
        if (fieldsList) {
            this.fieldsList = fieldsList;
        }
    }
}
class FormBeacon {
    constructor(name, stepName, lob, fields, events, fieldsList) {
        this.form = new Form(name, stepName, lob, fields, fieldsList);
        this.events = events;
    }
}
const errorEvent = 'error';
const AllEvents = [
    formView,
    formStepView,
    formComplete,
    'pageView',
    'productView',
    'buyFlowStart',
    'addToCart',
    'removeFromCart',
    'keepPlan',
    'cartView',
    'checkout',
    'orderReview',
    'notification',
    'paymentInfo',
    'buyFlowComplete',
    'purchase',
    'saveCart',
    'resumeCart',
    'miscellaneous',
    'serviceAvailCheck',
    'keepProducts',
    interactionEventName,
    cmsInteractionEventName,
    miscEventName,
    ArticleViewEvent,
    ArticleHelpfulnessEvent,
    'selfServeStart',
    'selfServeComplete',
    'autoPay',
    'errorEvent',
    ArticleFeedbackEvent,
    'keepProducts',
    'liveChatOpen',
    'liveChatStart',
    'vaStepView',
    'vaResponse'
];
/* This class will be overridden by parent app
   This is so SiteName can be injectable
   Angular does not allow strings to be passed in as injectable arguments.
*/
class SiteName {
} // will be a string
/*
  Will be an object where keys are url routes and values are the page name
  for example:
  {
    'https://www.rogers.com': 'home',
    'https://www.rogers.com/': 'home',
    'https://www.rogers.com/': {
      page: {
        name: 'home',
        hierarchy: []
      }
    },

  }
*/
class PageMap {
}
class Article {
    constructor(title, type, lob, events, feedback) {
        this.article = {
            title: '',
            type: '',
            lob: '',
            feedback: ''
        };
        this.events = new ArticleEvents();
        const errors = [];
        if (!title) {
            errors.push('title');
        }
        if (!type) {
            errors.push('type');
        }
        if (!lob) {
            errors.push('lob');
        }
        if (typeof events === 'undefined') {
            errors.push('event');
        }
        if (errors.length) {
            throw new Error(`Article ${errors.join(',')} ${errors.length > 1 ? 'is' : 'are'} required`);
        }
        this.article.title = title;
        this.article.type = type;
        this.article.lob = lob;
        if (feedback) {
            this.article.feedback = feedback;
            this.events.articleFeedback = true;
        }
        else if (events === ArticleEvent.articleView) {
            this.events.articleView = true;
            this.events.pageView = true;
        }
        else if (events === ArticleEvent.isHelpful.yes) {
            this.events.helpfulness = 'yes';
        }
        else if (events === ArticleEvent.isHelpful.no) {
            this.events.helpfulness = 'no';
        }
        else if (events === ArticleEvent.feedback) {
            this.events.articleFeedback = true;
        }
    }
}
class interceptorConfigs {
} //class to be overridden with provider from app team
// to be overriden in app.module.ts providers
class InterceptorConfigs {
}
// limit to only 24 hour time format with optional leading 0
const ShippingDateRegex = /(1\d|2[0-3]|(1|2|3|4|5|6|7|8|9)|0\d):((0|1|2|3|4|5)\d)-(1\d|2[0-3]|(0|1|2|3|4|5|6|7|8|9)|0\d):((0|1|2|3|4|5)\d)/;
function updateAvailableTimes(key, times) {
    const validTimes = times.split(',').reduce((prev, current) => {
        const match = current.match(ShippingDateRegex);
        return prev && match && match.length > 0;
    }, true);
    if (!validTimes) {
        console.warn('@rogers/analytics: ShippingDates, invalid time range input');
    }
    return times;
}
function validateShippingTimes(shippingTimes) {
    const invalidInput = shippingTimes.split(',').reduce((prev, current) => {
        const match = current.match(ShippingDateRegex);
        if (!match || match.length === 0) {
            return current;
        }
        return prev;
    }, '');
    if (invalidInput) {
        return `@rogers/analytics: ShippingTimes, invalid time range input: ${invalidInput}`;
    }
}
const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
function validateShippingDates(partial) {
    const errors = [];
    DAYS.forEach(key => {
        if (partial[key]) {
            const tempError = validateShippingTimes(partial[key]);
            if (tempError) {
                errors.push(tempError);
            }
        }
    });
    return errors;
}
class ShippingDates {
    constructor(partial) {
        const errors = validateShippingDates(partial);
        DAYS.forEach(key => {
            this[key] = partial[key];
        });
        if (errors.length) {
            console.warn('@rogers/analytics ShippingDates: Invalid Shipping Times', errors.join(''));
        }
    }
}
class Configurable {
}
const SigninEvents = {
    // rogers
    MY_ACCOUNT: 'MyAccount',
    NETWORK_AUTH: 'NetwrkAuth',
    PIN_AUTH: 'PinAuth',
    LOGIN_MY_ROGERS: 'Login-MyRogers',
    Login_My_Account: 'Login-MyAccount',
    LOGIN_BSS_S: 'Login-BSS-S',
    IGNITE_IPTV: 'Ignite IPTV',
    // fido
    MY_FIDO_ACCOUNT_HOLDER: 'MyFido | Account Holder',
    MY_FIDO: 'MyFido',
    MY_FIDO_SUBSCRIBER: 'MyFido | Subscriber',
    MY_FIDO_GROUP_ID_LOGIN: 'MyFido | Group ID login',
    MY_FIDO_PREPAID: 'MyFido | Prepaid',
    FACEBOOK: 'Facebook',
    FACEBOOK_ACCOUNT_HOLDER: 'Facebook | Account Holder',
    FACEBOOK_SUBSCRIBER: 'Facebook | Subscriber',
    FACEBOOK_PREPAID: 'Facebook | Prepaid',
    FACEBOOK_GROUP_ID_LOGIN: 'Facebook | Group ID login',
    // fido retail
    FACEBOOK_MY_FIDO: 'MyFido | Account Holder	2',
    ATTEMPT: 'signinAttempt',
    SUCCESS: 'signinSuccess'
};
class Signin {
}
class AuthenticationEvents {
    constructor(isSigninSuccess) {
        if (isSigninSuccess) {
            this.signinSuccess = true;
        }
        else {
            this.signinAttempt = true;
        }
    }
}
class AuthenticationBeacon {
    constructor(signinType, isSuccess) {
        this.signin = new Signin();
        this.signin.type = signinType;
        this.events = new AuthenticationEvents(isSuccess);
    }
}
class SearchEvents {
}
class Events extends SearchEvents {
    constructor(eventTypes) {
        super();
        eventTypes &&
            eventTypes.forEach(event => {
                if (AllEvents.indexOf(event) >= 0) {
                    this[event] = true;
                }
                else {
                    console.error(`${event} is not a valid analytics event type`);
                }
            });
    }
}
class Service {
    constructor(availability, type, id, postalCode) {
        this.availability = availability;
        this.type = type;
        this.id = id;
        if (!availability && !type && !id) {
            console.warn('@rogers/analytics: availability, type and id should not be falsey');
        }
        if (!availability) {
            console.warn('@rogers/analytics: service.availability should not be falsey');
        }
        else {
            if (type && id && type.length + id.length < 254) {
                console.warn('@rogers/analytics: The combined length of type and id must be less than 254 characters');
            }
            if (typeof postalCode === 'string') {
                this.postalCode = postalCode.toUpperCase();
                if (!postalCode.match(postalCodeRegex)) {
                    console.warn('@rogers/analytics: postalCode is invalid');
                }
            }
        }
    }
}
class ServiceCheck {
    constructor(service) {
        this.events = {
            serviceAvailCheck: true
        };
        if (service) {
            this.service = service;
        }
    }
}
class Interaction {
    constructor(type, name) {
        this.type = type;
        this.name = name;
    }
}
class CMSInteraction {
    constructor(type, ctaContext, campaignName, entryTitle, extraInfo) {
        this.type = type;
        this.ctaContext = ctaContext || 'no cta context';
        this.campaignName = campaignName || 'no campaign';
        this.entryTitle = entryTitle || 'no entry title';
        if (extraInfo) {
            this.extraInfo = extraInfo;
        }
    }
}
class Miscellaneous extends Interaction {
    constructor(a, b) {
        super(a, b);
    }
}
class IAccount {
}
class AddOn {
}
class Balance {
}
class Msf {
}
class DataBucket {
}
class Wireless {
}
class Account {
    constructor(userType, userName, type, BAN, CTN, dealerCode, agentType, wireless, internet, tv, homePhone, roles) {
        this.userType = userType;
        this.userName = userName;
        this.type = type;
        this.BAN = BAN;
        this.CTN = CTN;
        this.dealerCode = dealerCode;
        this.agentType = agentType;
        if (roles) {
            this.roles = roles;
        }
        if (homePhone) {
            this.homePhone = homePhone;
        }
        if (tv) {
            this.tv = tv;
        }
        if (internet) {
            this.internet = internet;
        }
        if (wireless) {
            this.wireless = wireless;
        }
        if (this.dealerCode) {
            if (!this.agentType) {
                console.error('when a dealerCode is set, there should be an agentType');
            }
            if (!this.userName) {
                console.error('when a dealerCode is set, there should be an userName');
            }
            if (this.type.toLowerCase() === 'consumer') {
                console.error('when a dealerCode is set, the type should be agent');
            }
        }
        if (this.agentType && this.type.toLowerCase() === 'consumer') {
            console.error('when agentType is set, type should be "agent"');
        }
    }
}
class ResultLink {
}
class Search {
}
class GlobalVariables {
    constructor(site = new Site(), page = new Page(), personalization = null, account, virtualAssistant) {
        this.site = new Site();
        this.page = new Page();
        site && (this.site = _.cloneDeep(site));
        page && (this.page = _.cloneDeep(page));
        account && (this.account = _.cloneDeep(account));
        personalization && (this.personalization = _.cloneDeep(personalization));
        virtualAssistant && (this.virtualAssistant = _.cloneDeep(virtualAssistant));
    }
}
class PageLoad extends GlobalVariables {
    constructor(site = new Site(), page = new Page(), personalization, account, virtualAssistant, events) {
        super(site, page, personalization, account, virtualAssistant);
        this.events = events;
    }
}
class SelfServeBeacon {
    constructor(events, type, name, revenue, paymentMethod, transactionID, channelsSwapped) {
        this.selfServe = {
            type: null,
            name: null
        };
        this.events = new Events();
        this.selfServe.type = type;
        this.selfServe.name = name;
        if (revenue) {
            this.selfServe.revenue = revenue;
        }
        if (paymentMethod) {
            this.selfServe.paymentMethod = paymentMethod;
        }
        if (transactionID) {
            this.selfServe.transactionID = transactionID;
            if (hasTransactionIDStub(this) && transactionID !== TRANSACTION_ID_SYMBOL) {
                throw new Error('Expected transactionID to be reference to the TRANSACTION_ID_SYMBOL exported from @rogers/analytics');
            }
        }
        if (channelsSwapped) {
            this.selfServe.channelsSwapped = channelsSwapped;
        }
        if (events.selfServeStart) {
            this.events.selfServeStart = true;
        }
        else if (events.selfServeComplete) {
            this.events.selfServeComplete = true;
        }
        else if (events.autoPay) {
            this.events.autoPay = true;
        }
    }
}
class InteractionEvent {
    constructor(interaction, service) {
        this.events = new Events([interactionEventName]);
        this.interaction = interaction;
        if (service) {
            this.service = service;
            this.events.serviceAvailCheck = true;
            if (service.availability === 'open') {
                this.events.pageView = true;
                this.page.url = 'modal popup';
                this.events.serviceAvailCheck = true;
            }
            delete this.events.interaction;
        }
    }
}
class CMSInteractionEvent {
    constructor(cmsInteraction) {
        this.events = new Events([cmsInteractionEventName]);
        this.cmsInteraction = cmsInteraction;
    }
}
// deprecated
class InteractionEventGlobal {
    constructor(type, name, events, site, page, account) {
        this.events = new Events([interactionEventName]);
        this.interaction = new Interaction(type, name);
        if (events) {
            this.events = events;
        }
        if (site) {
            this.site = site;
        }
        if (page) {
            this.page = page;
        }
        if (account) {
            this.account = account;
        }
    }
}
class MiscEventGlobal {
    constructor(type, name, events, site, page, account) {
        this.events = new Events([miscEventName]);
        this.miscellaneous = new Miscellaneous(type, name);
        if (events) {
            this.events = events;
        }
        if (site) {
            this.site = site;
        }
        if (page) {
            this.page = page;
        }
        if (account) {
            this.account = account;
        }
    }
}
class OptionalVariables {
}
class Video {
    constructor(name, player, id, options) {
        if (!name || !player || !id) {
            console.warn('Video Tracking requires name, player and id');
        }
        this.name = name;
        this.player = player;
        this.id = id;
        if (options) {
            if (options.hasOwnProperty('duration')) {
                this.duration = parseFloat(options.duration.toFixed(2));
            }
            if (options.hasOwnProperty('contentfulVideoName')) {
                this.contentfulVideoName = options.contentfulVideoName;
            }
        }
        if (name.length + player.length + id.length > 253) {
            console.warn('Video Name, Player, and id have a max length of 253 characters. Data will be truncated');
        }
    }
}
class VideoEvent {
    constructor(video, videoEvents) {
        if (video) {
            this.video = video;
        }
        if (!videoEvents || typeof videoEvents !== 'object' || Object.keys(videoEvents).length === 0) {
            console.warn('VideoEvent class should have at least one event.');
        }
        else {
            this.events = videoEvents;
        }
    }
}

const eventName$1 = 'adlEvent';
class PendingPayloadsSsrService {
    constructor(platform) {
        this.platform = platform;
        if (isPlatformBrowser(this.platform)) {
            if (window._analyticsHelpers) {
                window._analyticsHelpers.TRANSACTION_ID_SYMBOL = TRANSACTION_ID_SYMBOL;
                window._analyticsHelpers.queue = [];
            }
            else {
                window._analyticsHelpers = {
                    queue: [],
                    TRANSACTION_ID_SYMBOL: TRANSACTION_ID_SYMBOL
                };
            }
            // if there is an app in an iframe, the datalayer in the iframe will pass payloads to the parent.
            // the parent will use below event listener to listen for these payloads and send them to adobe analytics.
            window.addEventListener('message', event => {
                if (event.data && event.data.type === 'AnalyticsDataLayer' && event.data.payload) {
                    // document.getElementsByTagName('iframe')[0].contentWindow.postMessage({hello:{jon:'snow'}}, '*');
                    this.addPendingPayload(event.data.payload);
                }
            }, false);
        }
    }
    addPendingPayload(newPayload) {
        // check helper functions(and by extension adobe analytics is loaded);
        if (isPlatformBrowser(this.platform)) {
            // means we are in an iframe, send payload to parent window to dispatch to analytics
            // because parent window is aware of cookies that store hashed ban and v4 from the parent page is required
            if (window.parent !== window) {
                window.parent.postMessage({
                    type: 'AnalyticsDataLayer',
                    payload: newPayload
                }, '*');
            }
            else if (window._trackData) {
                this.dispatchEvent(newPayload);
            }
            else {
                window._analyticsHelpers.queue.push(newPayload);
                //this.clearQueue();
            }
        }
    }
    dispatchEvent(payload) {
        if (isPlatformBrowser(this.platform)) {
            try {
                window.AnalyticsDataLayer = payload;
                if (_.get(payload, 'events.pageView')) {
                    window._trackData(eventName$1, 'p', payload);
                }
                else {
                    window._trackData(eventName$1, 'a', payload);
                }
            }
            catch (err) {
                console.warn('pending-paylods.service: ', err);
            }
        }
    }
}
PendingPayloadsSsrService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsSsrService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
PendingPayloadsSsrService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsSsrService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsSsrService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

const eventName = 'adlEvent';
class PendingPayloadsService {
    // constructor(@Inject(PLATFORM_ID) private platform: Object) {
    constructor() {
        if (window._analyticsHelpers) {
            window._analyticsHelpers.TRANSACTION_ID_SYMBOL = TRANSACTION_ID_SYMBOL;
            window._analyticsHelpers.queue = [];
        }
        else {
            window._analyticsHelpers = {
                queue: [],
                TRANSACTION_ID_SYMBOL: TRANSACTION_ID_SYMBOL
            };
        }
        // if there is an app in an iframe, the datalayer in the iframe will pass payloads to the parent.
        // the parent will use below event listener to listen for these payloads and send them to adobe analytics.
        window.addEventListener('message', event => {
            if (event.data && event.data.type === 'AnalyticsDataLayer' && event.data.payload) {
                // document.getElementsByTagName('iframe')[0].contentWindow.postMessage({hello:{jon:'snow'}}, '*');
                this.addPendingPayload(event.data.payload);
            }
        }, false);
    }
    addPendingPayload(newPayload) {
        // check helper functions(and by extension adobe analytics is loaded);
        // means we are in an iframe, send payload to parent window to dispatch to analytics
        // because parent window is aware of cookies that store hashed ban and v4 from the parent page is required
        if (window.parent !== window) {
            window.parent.postMessage({
                type: 'AnalyticsDataLayer',
                payload: newPayload
            }, '*');
        }
        else if (window._trackData) {
            dispatchTrackingEvent(newPayload);
        }
        else {
            window._analyticsHelpers.queue.push(newPayload);
            //this.clearQueue();
        }
    }
}
PendingPayloadsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PendingPayloadsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PendingPayloadsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });
function dispatchTrackingEvent(payload) {
    try {
        window.AnalyticsDataLayer = payload;
        if (_.get(payload, 'events.pageView')) {
            window._trackData(eventName, 'p', payload);
        }
        else {
            window._trackData(eventName, 'a', payload);
        }
    }
    catch (err) {
        console.warn('pending-paylods.service: ', err);
    }
}

function cloneDeepWrapper(payload) {
    const transactionID = hasTransactionIDStub(payload) ? payload.selfServe.transactionID : null;
    const ret = cloneDeep(payload);
    if (transactionID) {
        ret.selfServe.transactionID = transactionID;
    }
    return ret;
}
const map = {
    province: 'page.province',
    language: 'page.language',
    page: 'page',
    personalization: 'personalization',
    virtualAssistant: 'virtualAssistant',
    account: 'account',
    authentication: 'signin',
    ecommerce: 'ecommerce',
    buyflow: 'buyflow',
    products: 'ecommerce.products',
    brandOrLOB: 'brandOrLOB'
};
let AnalyticsService = class AnalyticsService {
    constructor(observables, site, pageMap, pendingPayloadsService, applicationName, modalMap, platform) {
        this.pageMap = pageMap;
        this.pendingPayloadsService = pendingPayloadsService;
        this.applicationName = applicationName;
        this.modalMap = modalMap;
        this.platform = platform;
        this._previousPageObjects = [];
        this.revertPageBeforeLastModal = () => {
            if (this._previousPageObjects.length) {
                this._globalVariables.page = this._previousPageObjects.pop();
            }
        };
        this._globalVariables = new GlobalVariables();
        this.firstPageView = false;
        // used for debugging/testing/sandbox component
        this.payloadObserver = new BehaviorSubject({});
        this.ecommerce$ = new Subject();
        this.shipping$ = new Subject();
        this.serial = null;
        this.globalErrors = [];
        this.blackList = [
            'products',
            'personalization',
            'authentication',
            'segment',
            'page',
            'offers',
            'closeModalResetPage',
            'shipping',
            'shouldTrackBoldChat'
        ];
        if (isPlatformBrowser(this.platform)) {
            if (observables.shouldTrackBoldChat) {
                this._trackBoldChat();
            }
            document.body.addEventListener('openModal', (modalEvent) => {
                /*if (this.modalMap[modalEvent.detail.heading]) {
                  this.trackPageLoad(this.modalMap[modalEvent.detail.heading]);
                }*/
                const payLoad = this.modalMap(modalEvent.detail);
                if (payLoad) {
                    this.trackPageLoad(payLoad);
                }
            });
        }
        this.updateSerial();
        this._globalVariables.applicationName = this.applicationName;
        this.configuration(observables, site);
    }
    updateSerial() {
        if (isPlatformBrowser(this.platform)) {
            this.serial = sessionStorage.getItem('uniqueID');
            if (!this.serial) {
                const uniqueValue = new Date().valueOf() + Math.random();
                const uniqueString = uniqueValue.toString();
                this.serial = uniqueString.length > 19 ? uniqueValue.toString().substring(0, 19) : uniqueString;
                sessionStorage.setItem('uniqueID', this.serial);
            }
        }
    }
    configuration(observables, site) {
        this.configGlobals(site);
        for (const i in observables) {
            if (this.blackList.indexOf(i) >= 0) {
                continue;
            }
            observables[i].subscribe(data => {
                const path = map[i].split('.');
                if (path.length > 1) {
                    let ref = this._globalVariables;
                    // don't iterate to the last key
                    // we need ref to point to an object so that ref[lastKey] will update the original object
                    for (let k = 0; k < path.length - 1; k++) {
                        ref = ref[path[k]];
                    }
                    ref[path[path.length - 1]] = data;
                }
                else if (path.length === 1) {
                    this._globalVariables[path[0]] = data;
                }
                else if (isObject(data)) {
                    each(data, (val, key) => {
                        if (key === 'events') {
                            this._globalVariables.events = cloneDeepWrapper(val);
                        }
                        else {
                            this._globalVariables[key] = val;
                        }
                    });
                }
            });
        }
        this.ecommerce$.subscribe((ecommerce) => {
            this._globalVariables.ecommerce = ecommerce;
        });
        if (observables.hasOwnProperty('closeModalResetPage')) {
            // void observable, emits undefined. We're not looking for a value.
            // every time this emits, we should reset the page.
            observables.closeModalResetPage.subscribe(() => this.revertPageBeforeLastModal());
        }
        if (observables.hasOwnProperty('products')) {
            observables.products.subscribe(products => {
                if (!this._globalVariables.ecommerce) {
                    this._globalVariables.ecommerce = {};
                }
                this._globalVariables.ecommerce.products = cloneDeepWrapper(products);
            });
            delete observables.products;
        }
        const updateShipping = (shipping) => {
            let count = 0;
            if (!shipping.shipMethod) {
                if (this._globalVariables.ecommerce && this._globalVariables.ecommerce.hasOwnProperty('shipMethod')) {
                    delete this._globalVariables.ecommerce.shipMethod;
                }
                count++;
            }
            if (!shipping.shippingDatesAvailable) {
                if (this._globalVariables.ecommerce && this._globalVariables.ecommerce.hasOwnProperty('shippingDatesAvailable')) {
                    delete this._globalVariables.ecommerce.shippingDatesAvailable;
                }
                count++;
            }
            if (count === 2) {
                return;
            }
            if (!this._globalVariables.ecommerce) {
                this._globalVariables.ecommerce = {};
            }
            if (shipping.shipMethod) {
                this._globalVariables.ecommerce.shipMethod = shipping.shipMethod;
            }
            if (shipping.shippingDatesAvailable) {
                this._globalVariables.ecommerce.shippingDatesAvailable = cloneDeepWrapper(shipping.shippingDatesAvailable);
            }
        };
        if (observables.hasOwnProperty('shipping')) {
            merge(observables.shipping, this.shipping$).subscribe(updateShipping);
            delete observables.shipping;
        }
        else {
            this.shipping$.subscribe(updateShipping);
        }
        if (observables.hasOwnProperty('offers')) {
            observables.offers.subscribe(offers => {
                if (!this._globalVariables.ecommerce) {
                    this._globalVariables.ecommerce = {};
                }
                this._globalVariables.ecommerce.offers = cloneDeepWrapper(offers);
            });
            delete observables.offers;
        }
        if (observables.hasOwnProperty('fees')) {
            observables.fees.subscribe((fees) => {
                if (!this._globalVariables.ecommerce) {
                    this._globalVariables.ecommerce = {};
                }
                this._globalVariables.ecommerce.fees = cloneDeepWrapper(fees);
            });
            delete observables.fees;
        }
        if (observables.hasOwnProperty('personalization')) {
            observables.personalization.subscribe((personalization) => {
                if (!personalization || isEqual(personalization, this._globalVariables.personalization)) {
                    return;
                }
                const backupSegment = this._globalVariables.personalization && this._globalVariables.personalization.segment;
                this._globalVariables.personalization = cloneDeepWrapper(personalization);
                if (backupSegment) {
                    this._globalVariables.personalization.segment = backupSegment;
                }
                this.pendingPayloadWrapper(cloneDeepWrapper(this._globalVariables));
                // TODO fire analytics event
            });
            delete observables.personalization;
        }
        if (observables.hasOwnProperty('authentication')) {
            observables.authentication.subscribe((signInEvent) => {
                if (signInEvent) {
                    if (signInEvent.events.signinAttempt) {
                        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(signInEvent)));
                    }
                    else {
                        merge(this._globalVariables, cloneDeepWrapper(signInEvent));
                    }
                }
            });
            delete observables.authentication;
        }
        if (observables.hasOwnProperty('segment')) {
            observables.segment.subscribe(newSegment => {
                if (!this._globalVariables.personalization) {
                    this._globalVariables.personalization = {};
                }
                this._globalVariables.personalization.segment = newSegment;
            });
            delete observables.segment;
        }
        if (observables.hasOwnProperty('page')) {
            observables.page.subscribe(data => {
                this.trackPageLoad(data);
            });
            delete observables.page;
        }
    }
    validatePayload(pendingPayload) {
        if (pendingPayload.submissionOptions) {
            let totalLength = -1;
            for (let i = 0; i < pendingPayload.submissionOptions.length; i++) {
                const op = pendingPayload.submissionOptions[i];
                totalLength += op.answerId.length + op.questionId.length + 2;
            }
            if (totalLength > 255) {
                console.warn('datalayer-service WARNING: Total character length of SubmissionOptions is longer than 255. This will result in data loss.');
            }
        }
    }
    pendingPayloadWrapper(pendingPayload) {
        if (!pendingPayload.events && pendingPayload.personalization && window._analyticsHelpers.queue.length === 0) {
            return;
        }
        if (pendingPayload &&
            pendingPayload.selfServe &&
            pendingPayload.selfServe.transactionID &&
            typeof pendingPayload.selfServe.transactionID === 'object' &&
            pendingPayload.selfServe.transactionID !== TRANSACTION_ID_SYMBOL) {
            throw new Error('Expected transactionID to be reference to the TRANSACTION_ID_SYMBOL exported from @rogers/analytics');
        }
        const bf = pendingPayload.buyflow;
        if (bf && bf.name && !bf.serial) {
            bf.serial = this.serial; // add serial if it doesn't exist
        }
        if (pendingPayload.ecommerce && pendingPayload.ecommerce.shippingDatesAvailable) {
            const errors = validateShippingDates(pendingPayload.ecommerce.shippingDatesAvailable);
            if (errors.length) {
                console.warn('@rogers/analytics payload contains invalid shippingDatesAvailable: ', errors.join(','));
            }
        }
        this.validatePayload(pendingPayload);
        this.pendingPayloadsService.addPendingPayload(cloneDeepWrapper(pendingPayload));
        // cleanup all non-global data(things assigned via set functions);
        if (this._globalVariables.article) {
            delete this._globalVariables.article;
        }
        if (this._globalVariables.miscellaneous) {
            delete this._globalVariables.miscellaneous;
        }
        if (this._globalVariables.interaction) {
            delete this._globalVariables.interaction;
        }
        if (this._globalVariables.cmsInteraction) {
            delete this._globalVariables.cmsInteraction;
        }
        if (this._globalVariables.errors) {
            delete this._globalVariables.errors;
        }
        if (this._globalVariables.notification) {
            delete this._globalVariables.notification;
        }
        if (this._globalVariables.form) {
            delete this._globalVariables.form;
        }
        if (this._globalVariables.search) {
            delete this._globalVariables.search;
        }
        if (this._globalVariables.article) {
            delete this._globalVariables.article;
        }
        if (this._globalVariables.selfServe) {
            delete this._globalVariables.selfServe;
        }
        if (this._globalVariables.signin) {
            delete this._globalVariables.signin;
        }
        if (this._globalVariables) {
            this._globalVariables.events = {};
        }
        this.payloadObserver.next(pendingPayload);
    }
    // default site name to rogers
    configGlobals(siteName = 'R') {
        this._globalVariables.site.name = siteName;
    }
    set optionalGlobals(object) {
        merge(this._globalVariables, cloneDeepWrapper(object));
    }
    get globalVariables() {
        return this._globalVariables;
    }
    trackClick(payload, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(payload), cloneDeepWrapper(globalVariables)));
    }
    setClick(payload) {
        merge(this._globalVariables, payload);
    }
    trackCmsClick(payload, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(new CMSInteractionEvent(payload)), cloneDeepWrapper(globalVariables)));
    }
    setCmsClick(payload) {
        merge(this._globalVariables, new CMSInteractionEvent(payload));
    }
    trackVideo(payload, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(payload), cloneDeepWrapper(globalVariables)));
    }
    setVideo(payload) {
        merge(this._globalVariables, payload);
    }
    trackMisc(payload, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(payload), cloneDeepWrapper(globalVariables)));
    }
    setMisc(payload) {
        merge(this._globalVariables, payload);
    }
    mapPage(page) {
        return this.pageMap[page] || page;
    }
    trackPreviousPage() {
        if (this._globalVariables.page) {
            this._previousPageObjects.push(JSON.parse(JSON.stringify(this._globalVariables.page)));
        }
    }
    trackPageLoad(url, isModal, globalVariables = {}) {
        if (isModal || get(url, 'page.url') === 'modal popup' || get(url, 'page.hasPreviousPage')) {
            // if a modal opens, add the current page object to the queue so we can restore the page name after the modal closes.
            this.trackPreviousPage();
        }
        else {
            // if the user goes from a modal to a non-modal we can just clear the queue.
            // queue is only really useful when we have a chain of modals.
            this._previousPageObjects = [];
        }
        if (typeof url === 'string') {
            this.firstPageView = true;
            const hier = parseHierarchy(stripQueryParams(url));
            if (hier.length) {
                this._globalVariables.page.name = this.mapPage(hier[hier.length - 1]);
            }
            else {
                this._globalVariables.page.name = this.mapPage('') || '';
            }
            this._globalVariables.page.hierarchy = hier.slice(1, hier.length);
            this._globalVariables.page.channel = this._globalVariables.page.hierarchy[0] || this._globalVariables.page.name;
            const payload = new PageLoad(this._globalVariables.site, this._globalVariables.page, this._globalVariables.personalization, this._globalVariables.account, this._globalVariables.virtualAssistant, new Events(['pageView']));
            if (isModal) {
                payload.url = 'modal popup';
            }
            // merge(payload.events, this.globalVariables.events);
            if (!this._globalVariables.events) {
                this._globalVariables.events = {};
            }
            this.pendingPayloadWrapper(cloneDeepWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(globalVariables), cloneDeepWrapper(payload))));
            if (this._globalVariables.events) {
                delete this._globalVariables.events;
            }
        }
        else if (typeof url === 'object') {
            const currentPage = get(this._globalVariables, 'page');
            if (currentPage && get(url, 'page.hasPreviousPage')) {
                if (url.page) {
                    url.page.hierarchy = [...currentPage.hierarchy, url.page ? url.page.name : ''];
                }
            }
            const pageViewObject = cloneDeepWrapper(url);
            if (url.page) {
                for (const i in url.page) {
                    this._globalVariables.page[i] = url.page[i];
                }
            }
            if (!pageViewObject.events) {
                pageViewObject.events = {};
            }
            if (isModal) {
                if (!pageViewObject.page) {
                    pageViewObject.page = {};
                }
                pageViewObject.page.url = 'modal popup';
            }
            pageViewObject.events.pageView = true;
            this.pendingPayloadWrapper(cloneDeepWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(globalVariables), pageViewObject)));
        }
    }
    revertToPreviousPage() {
        if (this._previousPageObjects.length) {
            this._globalVariables.page = this._previousPageObjects.pop();
        }
    }
    trackErrors(errors, globalVariables = {}) {
        const errorPayload = new AnalyticsErrorBeacon(cloneDeepWrapper(errors));
        const payload = merge(cloneDeepWrapper(this._globalVariables), errorPayload, cloneDeepWrapper(globalVariables));
        this.pendingPayloadWrapper(payload);
    }
    setErrors(errors) {
        merge(this._globalVariables, cloneDeepWrapper(new AnalyticsErrorBeacon(errors)));
    }
    trackNotifications(notifications, globalVariables = {}) {
        const notificationPayload = new NotificationBeacon(cloneDeepWrapper(notifications));
        const payload = merge(cloneDeepWrapper(this._globalVariables), notificationPayload, cloneDeepWrapper(globalVariables));
        this.pendingPayloadWrapper(payload);
    }
    setNotifications(notifications) {
        merge(this._globalVariables, cloneDeepWrapper(new NotificationBeacon(notifications)));
    }
    trackForm(form, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(globalVariables), cloneDeepWrapper(form)));
    }
    setForm(form) {
        merge(this._globalVariables, cloneDeepWrapper(form));
    }
    trackSearch(search, globalVariables = {}) {
        const e = cloneDeepWrapper({ events: search.events });
        const s = cloneDeepWrapper({ search: search });
        if (s.search.hasOwnProperty('events')) {
            delete s.search.events;
        }
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), s, e, cloneDeepWrapper(globalVariables)));
    }
    setSearch(search) {
        merge(this._globalVariables, cloneDeepWrapper(search));
    }
    trackArticle(article, globalVariables = {}) {
        const payload = merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(globalVariables), cloneDeepWrapper(article));
        this.pendingPayloadWrapper(payload);
    }
    setArticle(article) {
        merge(this._globalVariables, cloneDeepWrapper(article));
    }
    setVirtualAssistant(va) {
        this._globalVariables.virtualAssistant = cloneDeepWrapper(va);
    }
    trackVirtualAssistant(va) {
        const payload = merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper({ virtualAssistant: va }));
        this.pendingPayloadWrapper(payload);
    }
    setVirtualAssistantStep(stepIntentName) {
        if (!this._globalVariables.virtualAssistant) {
            this._globalVariables.virtualAssistant = {};
        }
        this._globalVariables.virtualAssistant = {
            ...this._globalVariables.virtualAssistant,
            ...stepIntentName
        };
    }
    trackVirtualAssistantStep(stepIntentName, globalVariables) {
        this.setVirtualAssistantStep(stepIntentName);
        if (!globalVariables) {
            globalVariables = {};
        }
        if (!globalVariables.events) {
            globalVariables.events = {};
        }
        globalVariables.events.vaStepView = true;
        this.pendingPayloadWrapper(merge(this._globalVariables, JSON.parse(JSON.stringify(globalVariables))));
    }
    trackVirtualAssistantResponse(va) {
        const payload = merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper({ virtualAssistant: va }));
        payload.events.vaResponse = true;
        this.pendingPayloadWrapper(payload);
    }
    ///SelfServe
    trackSelfServe(selfServe, globalVariables = {}) {
        const payload = merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(selfServe), cloneDeepWrapper(globalVariables));
        this.pendingPayloadWrapper(payload);
    }
    setSelfServe(selfServe) {
        merge(this._globalVariables, cloneDeepWrapper(selfServe));
    }
    trackArticleFeedback(articleFeedBack) {
        const payload = merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(articleFeedBack));
        this.pendingPayloadWrapper(payload);
    }
    setArticleFeedback(articleFeedBack) {
        merge(this._globalVariables, cloneDeepWrapper(articleFeedBack));
    }
    trackServiceAvailability(service, globalVariables = {}) {
        this.pendingPayloadWrapper(merge(cloneDeepWrapper(this._globalVariables), cloneDeepWrapper(service), cloneDeepWrapper(globalVariables)));
    }
    setServiceAvailability(service) {
        merge(this._globalVariables, cloneDeepWrapper(service));
    }
    trackLiveChat(referrer, id) {
        const liveChat = {
            liveChat: {
                referrer
            }
        };
        if (id) {
            liveChat.liveChat.id = id;
        }
        const payload = merge(cloneDeepWrapper(this._globalVariables), liveChat);
        this.pendingPayloadWrapper(payload);
    }
    trackBuyFlowCompleteV2(e, globalVariables) {
        const payload = JSON.parse(JSON.stringify({
            ...this._globalVariables,
            ...globalVariables
        }));
        payload.ecommerce = {
            ...payload.ecommerce,
            ...e
        };
        payload.events = {
            buyFlowComplete: true,
            purchase: true
        };
        this.pendingPayloadWrapper(payload);
    }
    trackBuyFlowComplete(minimalEcommerce) {
        const payload = cloneDeepWrapper(this._globalVariables);
        payload.ecommerce = cloneDeepWrapper({
            ...minimalEcommerce,
            products: this._globalVariables.ecommerce.products,
            fees: this._globalVariables.ecommerce.fees,
            offers: this._globalVariables.ecommerce.offers
        });
        payload.events = {
            buyFlowComplete: true,
            purchase: true
        };
        this.pendingPayloadWrapper(payload);
    }
    intercept(req, next) {
        for (const i in this.interceptorConfigs) {
            if (this.interceptorConfigs[i].shouldInterceptRequest(req)) {
                this.interceptorConfigs[i].requestInterceptor(req);
            }
        }
        return next.handle(req).pipe(tap((resp) => {
            if (resp.type) {
                for (const i in this.interceptorConfigs) {
                    if (this.interceptorConfigs[i].shouldInterceptResponse(req, resp)) {
                        this.interceptorConfigs[i].responseInterceptor(req, resp);
                    }
                }
            }
        }), catchError((err) => {
            for (const i in this.interceptorConfigs) {
                if (this.interceptorConfigs[i].shouldHandleError &&
                    this.interceptorConfigs[i].errorHandler &&
                    this.interceptorConfigs[i].shouldHandleError(req, err)) {
                    this.interceptorConfigs[i].errorHandler(req, err);
                }
            }
            if (this.globalErrors.indexOf(req.url) >= 0) {
                this.trackErrors([
                    {
                        API: req.url,
                        code: err.status.toString(),
                        type: 'http',
                        category: 'self serve',
                        field: '',
                        message: err.message
                    }
                ]);
            }
            throw err;
        }));
    }
    _trackBoldChat() {
        // bold chat
        const error_message = '@rogers/analytics BoldChat tracking: ';
        try {
            const CONTAINER = {};
            const w = window;
            if (!w._analyticsHelpers) {
                w._analyticsHelpers = {};
            }
            const _analyticsHelpers = w._analyticsHelpers;
            let isSet = false;
            CONTAINER._bcvmf2 = {};
            Object.defineProperty(window, '_bcvmf', {
                set: function (x) {
                    try {
                        if (!isSet) {
                            isSet = true;
                            const originalButton = x.floatButton;
                            x.floatButton = function () {
                                try {
                                    arguments && (_analyticsHelpers.cbdid = arguments[0].id || arguments[0].bdid);
                                    return originalButton.apply(x, arguments);
                                }
                                catch (e) {
                                    console.warn(error_message, e);
                                    try {
                                        return originalButton.apply(x, arguments);
                                    }
                                    catch (err) { }
                                }
                            };
                            CONTAINER._bcvmf2 = x;
                        }
                    }
                    catch (e) {
                        console.warn(error_message, e);
                    }
                },
                get: function () {
                    try {
                        return CONTAINER._bcvmf2;
                    }
                    catch (e) {
                        console.warn(error_message, e);
                    }
                }
            });
            let isSet2 = false;
            CONTAINER._bcvmb2 = {};
            Object.defineProperty(window, '_bcvmb', {
                set: function (x) {
                    try {
                        if (!isSet2) {
                            isSet2 = true;
                            const originalButton = x.button;
                            x.button = function () {
                                try {
                                    arguments && (_analyticsHelpers.cbdid2 = arguments[0].bdid);
                                    return originalButton.apply(x, arguments);
                                }
                                catch (e) {
                                    console.warn(error_message, e);
                                }
                            };
                            CONTAINER._bcvmb2 = x;
                        }
                    }
                    catch (e) {
                        console.warn(error_message, e);
                    }
                },
                get: function () {
                    try {
                        return CONTAINER._bcvmb2;
                    }
                    catch (e) {
                        console.warn(error_message, e);
                    }
                }
            });
            //----------------------------------
            // Listening to liveChat events
            //----------------------------------
            let liveChatStarted = false;
            let liveChatOpened = false;
            const getLiveChatPayload = liveChatEvent => {
                try {
                    const payload = {
                        liveChat: {
                            referrer: null
                        },
                        events: {
                            [liveChatEvent]: true
                        }
                    };
                    this.pendingPayloadWrapper(merge(JSON.parse(JSON.stringify(this._globalVariables)), cloneDeepWrapper(payload)));
                }
                catch (e) {
                    console.warn(error_message, e);
                }
            };
            w.bc_newHistoryMessageCallback = function () {
                try {
                    if (liveChatStarted === false) {
                        getLiveChatPayload('liveChatStart');
                        liveChatStarted = true;
                    }
                }
                catch (e) {
                    console.warn(error_message, e);
                }
            };
            w.bc_chatEndedEventCallback = function () {
                liveChatStarted = false;
            };
            w.bc_chatClosedEventCallback = function () {
                liveChatOpened = false;
            };
            w.bc_chatWindowLoadedEventCallback = function () {
                try {
                    if (liveChatOpened === false) {
                        getLiveChatPayload('liveChatOpen');
                        liveChatOpened = true;
                    }
                }
                catch (e) {
                    console.warn(error_message, e);
                }
            };
        }
        catch (e) {
            console.warn(error_message, e);
        }
    }
};
AnalyticsService = __decorate([
    __param(6, Inject(PLATFORM_ID))
], AnalyticsService);
function parseHierarchy(url) {
    return url.split('/');
}
function stripQueryParams(url) {
    const queryIndex = url.indexOf('?');
    if (queryIndex >= 0) {
        return url.substring(0, queryIndex);
    }
    return url;
}
function merge(...args) {
    if (args.length === 1) {
        return args[0];
    }
    else if (args.length > 1) {
        return args.reduce(reducer);
    }
}
function reducer(prev, current) {
    for (const i in current) {
        if (!isFunction(prev[i])) {
            if (!isObject(prev[i])) {
                prev[i] = current[i];
            }
            else {
                prev[i] = reducer(prev[i], current[i]);
            }
        }
    }
    return prev;
}

class AnalyticsModule {
}
AnalyticsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AnalyticsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AnalyticsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AnalyticsModule });
AnalyticsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AnalyticsModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AnalyticsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [],
                    exports: [],
                    providers: []
                }]
        }] });

/*
 * Public API Surface of analytics
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Account, AddOn, AnalyticsErrorBeacon, AnalyticsModule, AnalyticsService, ApplicationName, Article, ArticleEvent, ArticleEvents, ArticleFeedback, ArticleFeedbackEvent, ArticleHelpfulnessEvent, ArticleViewEvent, AuthenticationBeacon, AuthenticationEvents, Balance, CMSInteraction, CMSInteractionEvent, Configurable, DAYS, DataBucket, Events, Field, Form, FormBeacon, GlobalVariables, IAccount, Interaction, InteractionEvent, InteractionEventGlobal, InterceptorConfigs, MinimalPage, MiscEventGlobal, Miscellaneous, Msf, NotificationBeacon, OptionalVariables, Page, PageLoad, PageMap, PendingPayloadsService, PendingPayloadsSsrService, ResultLink, Search, SearchEvents, SelfServeBeacon, SelfServeEvents, Service, ServiceCheck, ShippingDateRegex, ShippingDates, Signin, SigninEvents, Site, SiteName, TRANSACTION_ID_SYMBOL, Video, VideoEvent, Wireless, hasTransactionIDStub, interceptorConfigs, postalCodeRegex, updateAvailableTimes, validateShippingDates, validateShippingTimes };
